import { Component, Inject, OnInit, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatTabGroup } from '@angular/material/tabs';
import { Router } from '@angular/router';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { CalendarOptions, DateSelectArg } from '@fullcalendar/core';
import * as moment from 'moment';
import { Booking } from 'src/app/core/models/booking.model';
import { SelectTime, User } from 'src/app/core/models/user';
import { BookingsService } from 'src/app/core/services/bookings.service';
import { UserService } from 'src/app/core/services/user.service';


@Component({
  selector: 'app-welcome-modal',
  templateUrl: './welcome-modal.component.html',
  styleUrls: ['./welcome-modal.component.scss']
})
export class WelcomeModalComponent implements OnInit {
  register: FormGroup;
  @ViewChild('tabs') tabGroup: MatTabGroup;
  @ViewChildren(FullCalendarComponent) fullCalendars: FullCalendarComponent[];
  selectedTimes: SelectTime[] = [];

  datesError = false;
  user: User;
  eventIds = 0;
  events = [{
    id: `${this.eventIds}`,
    start: '2021-10-10T10:00:00',
    end: '2021-10-10T16:00:00',

    className: "fc-event-primary",
  }
  ];


  startTime = { hour: 10, minute: 30 };
  endTime = { hour: 15, minute: 30 };
  currentDateStr: string;
  currentDate: Date;
  currentEventId = '1';
  timeZoneString = 'Select timezone';
  timeZoneError = false;
  showNoTimesError = false;
  constructor(private fb: FormBuilder, @Inject(MAT_DIALOG_DATA) public data: any, private userService: UserService, private bookingsService: BookingsService, private router: Router, private parentDilogRef: MatDialogRef<WelcomeModalComponent>) {
    this.selectedTimes = [];
    this.initForm();
  }

  initForm() {
    this.register = this.fb.group({
      hourRate: ['', [Validators.required, Validators.pattern('^[0-9]*[.]?[0-9]{0,2}$')]]
    });
  }

  setHourlyRate() {
    if (this.register.get('hourRate').errors == null) {
      this.tabGroup.selectedIndex = 1;
    }
  }
  changeTimezone(timezone) {
    this.user.timeZone = timezone;
  }
  saveTimezone() {
    if (this.user.timeZone) {
      this.timeZoneError = false;
      this.tabGroup.selectedIndex = 3;
    } else {
      this.timeZoneError = true;
    }
  }
  saveTimes(skipped) {
    console.log('Times ', this.selectedTimes);
    if (this.selectedTimes.length > 0) {
      this.showNoTimesError = false;
      if (!skipped) {
        this.tabGroup.selectedIndex = 2;
      } else {
        this.tabGroup.selectedIndex = 2;
      }
    } else {
      this.showNoTimesError = true;
    }
  }

  back(toStep: number) {
    this.tabGroup.selectedIndex = toStep;
  }
  updateTimes(times: SelectTime[]) {
    this.selectedTimes = times;
    console.log('Times ', this.selectedTimes);
  }
  /* Figure out best error catching implementation */
  async saveUser() {
    try {
      //await this.saveDateTime();
      this.user.acceptsClients = false;
      this.user.ratePerHour = +this.register.get('hourRate').value;
      this.user.timeRanges = this.selectedTimes;
      this.user.isInstructor = true;
      await this.userService.updateUser(this.user);

    } catch (e) {
      console.log('ERROR SAVING USER TO GO LIVE');
    }
    await this.delay(1000);
    window.location.reload();
  }
  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  async saveDateTime() {
    const bookings = [];
    const user = this.user;
    if (user) {
      for (let i = 0; i < this.selectedTimes.length; i++) {
        const start = moment(this.selectedTimes[i].start);
        const end = moment(this.selectedTimes[i].end);
        const diff = end.diff(start, 'hours');
        const booking = new Booking();
        booking.instructorId = user.userId;
        booking.startDateTime = start.toDate();
        booking.dateStr = start.format('yyyy-MM-DD');
        bookings.push(booking);
        let tempDate = start.clone();
        for (let j = 0; j < diff; j++) {
          const newDate = tempDate.add(1, 'hours');
          const booking = new Booking();
          booking.instructorId = user.userId;
          booking.startDateTime = newDate.toDate();
          booking.dateStr = newDate.format('yyyy-MM-DD');
          bookings.push(booking);
          tempDate = newDate.clone();
        }
      }

      await this.bookingsService.insertAvailbleDates(bookings);
    } else {
      console.log('USER UNDEFINED');
    }
  }

  ngOnInit() {
    this.userService.getUser(this.data.userId).subscribe(user => {
      this.user = user;
    });
  }

}
